enum NutritionTrackingApp {
  Yes = "Yes",
  Not_right_now="I have in the past",
  No = "No",

}

const nutritionTrackingAppQuestion = {
  name: "nutritiontrackingapp",
  descriptionLocation: "underTitle",
  title: `Do you currently use a <div class='highlight'>nutrition tracking</div> app?`,
  description: 'This helps us understand where you’re starting from.',
  type: "radiogroup",
  choices: Object.values(NutritionTrackingApp),
  isRequired: true,
};

export { NutritionTrackingApp, nutritionTrackingAppQuestion };
